import React, { useState } from 'react';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../firebase';
import { Link, useNavigate } from 'react-router-dom';
import { FiMail, FiArrowLeft, FiAlertCircle, FiCheckCircle } from 'react-icons/fi';

const PasswordResetPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleReset = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await sendPasswordResetEmail(auth, email);
      setSuccess(true);
      setLoading(false);
    } catch (err) {
      console.error('❌ Reset error:', err.code);
      setLoading(false);

      if (err.code === 'auth/user-not-found') {
        setError('❌ Ezzel az email címmel nem találtunk regisztrált felhasználót.');
      } else if (err.code === 'auth/invalid-email') {
        setError('❌ Érvénytelen email formátum.');
      } else {
        setError('❌ Hiba történt a küldés során. Kérlek próbáld újra később!');
      }
    }
  };

  const containerStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '80vh',
    padding: '20px',
    backgroundColor: '#f4f6f8',
    fontFamily: 'Arial, sans-serif'
  };

  const cardStyle = {
    backgroundColor: '#fff',
    borderRadius: '12px',
    boxShadow: '0 8px 30px rgba(0,0,0,0.12)',
    width: '100%',
    maxWidth: '450px',
    padding: '2.5rem',
    boxSizing: 'border-box',
    textAlign: 'center'
  };

  const titleStyle = {
    color: '#b30000',
    fontSize: '1.8rem',
    fontWeight: '900',
    marginBottom: '1rem',
    marginTop: 0
  };

  const subtitleStyle = {
    color: '#666',
    fontSize: '0.95rem',
    lineHeight: '1.5',
    marginBottom: '2rem'
  };

  const warningBoxStyle = {
    backgroundColor: '#fffbe6',
    border: '1px solid #ffe58f',
    borderRadius: '8px',
    padding: '15px',
    marginBottom: '20px',
    textAlign: 'left',
    display: 'flex',
    gap: '12px',
    alignItems: 'flex-start'
  };

  const inputStyle = {
    width: '100%',
    padding: '12px 15px',
    borderRadius: '8px',
    border: '1px solid #ddd',
    fontSize: '1rem',
    marginBottom: '1.5rem',
    boxSizing: 'border-box',
    outline: 'none',
    transition: 'border-color 0.2s'
  };

  const buttonStyle = {
    width: '100%',
    backgroundColor: '#b30000',
    color: 'white',
    padding: '12px',
    borderRadius: '8px',
    border: 'none',
    fontSize: '1rem',
    fontWeight: 'bold',
    cursor: loading ? 'not-allowed' : 'pointer',
    opacity: loading ? 0.7 : 1,
    transition: '0.3s'
  };

  const backLinkStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    marginTop: '20px',
    color: '#666',
    textDecoration: 'none',
    fontSize: '0.9rem',
    fontWeight: 'bold'
  };

  if (success) {
    return (
      <div style={containerStyle}>
        <div style={cardStyle}>
          <div style={{ color: '#28a745', marginBottom: '20px' }}>
            <FiCheckCircle size={60} />
          </div>
          <h2 style={titleStyle}>Email elküldve!</h2>
          <p style={subtitleStyle}>
            A jelszó visszaállításához szükséges hivatkozást elküldtük a(z) <strong>{email}</strong> címre.
          </p>
          <div style={warningBoxStyle}>
            <FiAlertCircle size={24} color="#faad14" style={{ flexShrink: 0 }} />
            <p style={{ margin: 0, fontSize: '0.85rem', color: '#856404', lineHeight: '1.4' }}>
              <strong>FONTOS:</strong><br />
              Ha nem találod a levelet 1-2 percen belül, kérlek nézd meg a <strong>SPAM</strong> vagy <strong>LEVÉLSZEMÉT (Junk)</strong> mappákat is!
            </p>
          </div>
          <button
            style={buttonStyle}
            onClick={() => navigate('/')}
          >
            Vissza a főoldalra
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <h2 style={titleStyle}>Jelszó visszaállítása</h2>
        <p style={subtitleStyle}>
          Add meg a fiókodhoz tartozó email címet, és küldünk egy hivatkozást az új jelszó beállításához.
        </p>

        <form onSubmit={handleReset}>
          <div style={{ position: 'relative', textAlign: 'left' }}>
            <label style={{ fontSize: '0.8rem', fontWeight: 'bold', color: '#b30000', marginBottom: '5px', display: 'block' }}>
              EMAIL CÍM
            </label>
            <input
              type="email"
              placeholder="pelda@email.hu"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={inputStyle}
            />
          </div>

          <div style={warningBoxStyle}>
            <FiAlertCircle size={24} color="#faad14" style={{ flexShrink: 0 }} />
            <p style={{ margin: 0, fontSize: '0.85rem', color: '#856404', lineHeight: '1.4' }}>
              <strong>FONTOS:</strong><br />
              Ha nem találod a levelet 1-2 percen belül, kérlek nézd meg a <strong>SPAM</strong> vagy <strong>LEVÉLSZEMÉT (Junk)</strong> mappákat is!
            </p>
          </div>

          {error && (
            <div style={{ color: '#cf1322', backgroundColor: '#fff1f0', border: '1px solid #ffa39e', padding: '10px', borderRadius: '6px', marginBottom: '20px', fontSize: '0.85rem' }}>
              {error}
            </div>
          )}

          <button type="submit" style={buttonStyle} disabled={loading}>
            {loading ? 'Küldés folyamatban...' : 'Hivatkozás küldése'}
          </button>
        </form>

        <Link to="/" style={backLinkStyle}>
          <FiArrowLeft /> Vissza a bejelentkezéshez
        </Link>
      </div>
    </div>
  );
};

export default PasswordResetPage;
